var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.385 14.359h5.384v15.256H5.385V14.36zm18.075-.52c1.516.008 3.455.753 4.64 1.956 1.228 1.373 1.515 2.925 1.515 4.846v8.974h-5.384v-8.337c0-1.525-.619-3.384-2.638-3.446-1.184.019-1.947.7-2.514 1.849-.161.377-.125.8-.125 1.22l-.108 8.714h-5.385V14.36h5.385l.108 1.992a5.556 5.556 0 011.517-1.641c.861-.62 1.867-.855 2.989-.872zM8.077 7.045c1.382.019 2.755 1.104 2.809 2.755.036 1.473-1.248 2.755-2.845 2.755h-.036c-1.373 0-2.72-1.122-2.782-2.755.027-1.454 1.248-2.718 2.854-2.755zM0 0v35h35V0H0z",
    fill: "#fff"
  })));
}

export default SvgLinkedin;